"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProductNavContent = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/es.array.reduce.js");
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
var _ProductNavItems = require("./items/ProductNavItems");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
const useStyles = (0, _core.makeStyles)(theme => ({
  subcategory: {
    fontWeight: 600,
    fontSize: '.8rem',
    marginBottom: '3px'
  },
  divider: {
    maxWidth: '90%',
    background: 'rgba(0, 0, 0, 0.3)'
  }
}));
const FieldServiceProducts = _ref => {
  let {
    items,
    close
  } = _ref;
  const [sortedProducts, setSortedProducts] = (0, _react.useState)([]);
  const classes = useStyles();
  (0, _react.useEffect)(() => {
    const groupedData = items.reduce((groups, obj) => {
      const {
        subcategory
      } = obj;
      if (!groups[subcategory]) {
        groups[subcategory] = [];
      }
      groups[subcategory].push(obj);
      return groups;
    }, {});
    setSortedProducts(Object.values(groupedData));
  }, []);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, sortedProducts.map((category, index) => /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    item: true,
    xs: true,
    key: index,
    spacing: 1,
    justifyContent: "flex-start",
    direction: "column"
  }, /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "body2",
    className: classes.subcategory
  }, category[0].subcategory), /*#__PURE__*/_react.default.createElement(_core.Divider, {
    className: classes.divider
  }), /*#__PURE__*/_react.default.createElement(_ProductNavItems.ProductNavItems, {
    items: category,
    noHeaderWidth: true,
    close: close
  }))));
};
const ProductNavContent = _ref2 => {
  let {
    header,
    content,
    close
  } = _ref2;
  return /*#__PURE__*/_react.default.createElement(_core.Grid, {
    container: true,
    direction: "row",
    spacing: 1
  }, content[0].subcategory ? /*#__PURE__*/_react.default.createElement(FieldServiceProducts, {
    items: content,
    noHeaderWidth: null,
    close: close
  }) : /*#__PURE__*/_react.default.createElement(_ProductNavItems.ProductNavItems, {
    items: content,
    noHeaderWidth: true,
    close: close,
    solutions: true
  }));
};
exports.ProductNavContent = ProductNavContent;